export default __webpack_public_path__ + "e7068bbce0757878c2ef3e30191ce580.svg";